<template>
  <Layout>
    <template #header> 容错备份 </template>
    <div class="row q-col-gutter-x-md full-height">
      <div class="col-3 column justify-around">
        <q-card bordered class="full-height column">
          <q-card-section class="row q-pb-none" style="flex: 1">
            <div
              :style="{
                position: 'absolute',
                left: '70px',
                top: '90px',
                width: '150px',
              }"
            >
              <img
                :src="
                  forwardTurningFailure === '前转正常' ? 前轮转角 : 前轮转角2
                "
                :style="{ width: '100px',marginLeft: '-30px' }"
              />
              <q-toggle
                v-model="forwardTurningFailure"
                color="red-10"
                false-value="前转正常"
                true-value="前转失效"
                :disable="forwardTurningIssue"
                size="xl"
              /><span style="font-weight: bold; font-size: 16px">前转失效</span>
            </div>
            <!-- 后转状态切换按钮 -->
            <div
              :style="{
                position: 'absolute',
                left: '70px',
                bottom: '180px',
                width: '150px',
              }"
            >
              <img
                :src="
                  reverseTurningFailure === '后转开启' ? 后轮转角 : 后轮转角2
                "
                :style="{ width: '100px', marginLeft: '-30px'  }"
              />
              <q-toggle
                v-model="reverseTurningFailure"
                color="red-10"
                false-value="后转开启"
                true-value="后转关闭"
                size="xl"
              /><span style="font-weight: bold; font-size: 16px">后转失效</span>
            </div>
          </q-card-section>
        </q-card>
      </div>
      <div class="col-9 column justify-around">
        <q-card bordered class="full-height column">
          <q-card-section class="row q-pb-none" style="flex: 1">
            <div
              class="row justify-around items-center car-img"
              style="flex: 1"
            >
              <!-- 车辆底盘图片 -->
              <q-img
                :src="底盘透明_纵向_不带轮胎"
                :style="{
                  height: IMG_HEIGHT + 'px',
                  width: IMG_WIDTH + 'px',
                }"
                spinner-color="white"
                fit="contain"
              >
                <!-- 轮胎 -->
                <q-img
                  v-for="(tire, index) in tires"
                  :key="tire.name"
                  :style="{
                    position: 'absolute',
                    left: tire.position.left + 'px',
                    top: tire.position.top + 'px',
                    right: tire.position.right + 'px',
                    bottom: tire.position.bottom + 'px',
                    width: TIRES_WIDTH + 'px',
                    height: TIRES_HEIGHT + 'px',
                  }"
                  :src="tire.src"
                  alt="tire"
                >
                  <!-- 轮胎状态背景色 -->
                  <div
                    class="absolute-full"
                    :style="`background-color: ${
                      tire.status === '制动失效'
                        ? 'rgba(247, 0, 0, 1)'
                        : 'rgba(76, 175, 80, 1)'
                    }; border-radius: 10px; width: 110%;`"
                  ></div>
                  <!-- 制动力和驱动力仪表 -->
                  <div
                    :style="{
                      position: 'absolute',
                      left: tire.gaugePosition.left + 'px',
                      top: tire.gaugePosition.top + 'px',
                      right: tire.gaugePosition.right + 'px',
                      bottom: tire.gaugePosition.bottom + 'px',
                      zIndex: 9,
                      transform: 'rotate(180deg)',
                    }"
                    class="absolute"
                  >
                    <!-- 制动力 -->
                    <ArrowGauge
                      :key="'arrow-top'"
                      :class="'arrow-top'"
                      :value="tire.status === '制动失效' ? 0 : tire.topValues"
                      :max="3000"
                      :color="'#ff5722'"
                    />
                    <!-- 驱动力 -->
                    <ArrowGauge
                      :key="'arrow-bottom'"
                      :class="'arrow-bottom'"
                      :value="tire.bottomValues * 11.5"
                      :max="4000"
                      :color="'#2196f3'"
                    />
                  </div>
                  <!-- 轮胎状态切换按钮 -->
                  <div
                    :style="{
                      position: 'absolute',
                      left: tire.radioPosition.left + 'px',
                      top: tire.radioPosition.top + 'px',
                      right: tire.radioPosition.right + 'px',
                      bottom: tire.radioPosition.bottom + 'px',
                      zIndex: 9,
                    }"
                    class="absolute"
                  >
                    <span style="font-weight: bold; font-size: 16px">
                      {{
                        tire.name === "左后" || tire.name === "左前"
                          ? "制动失效"
                          : ""
                      }}</span
                    >
                    <q-toggle
                      v-model="tire.status"
                      @update:model-value="
                        (value) => handleTireStatusChange(index, value)
                      "
                      color="red-10"
                      false-value="制动正常"
                      true-value="制动失效"
                      size="xl"
                      :disable="tire.disable"
                    />
                    <span style="font-weight: bold; font-size: 16px">{{
                      tire.name === "右后" || tire.name === "右前"
                        ? "制动失效"
                        : ""
                    }}</span>
                  </div>
                </q-img>
              </q-img>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import Layout from "./components/Layout.vue";
import ArrowGauge from "@/components/ArrowGauge.vue";
import 底盘透明_纵向_不带轮胎 from "@/assets/img/底盘透明_纵向_不带轮胎.png";
import 轮胎左 from "@/assets/img/轮胎左.png";
import 前轮转角 from "@/assets/img/前轮转角.png";
import 后轮转角 from "@/assets/img/后轮转角.png";
import 前轮转角2 from "@/assets/img/前轮转角 (2).png";
import 后轮转角2 from "@/assets/img/后轮转角 (2).png";
import useInitialize from "@/composables/domainControl/useInitialize";
import { SERVICE } from "@/services/domainControl/define";
import {
  generateMockIFTFNofifyData,
  NOTIFY,
} from "@/services/domainControl/iftf";
import { buildStatus, FunctionStatus, parseStatus } from "./helper/iftf";
import { useDomainControlStore } from "@/stores/domainControl";
import { onBeforeRouteLeave } from "vue-router";
import { useQuasar } from "quasar";
const $q = useQuasar();
// 图片尺寸计算
const IMG_HEIGHT = 550;
const CAR_HEIGHT = 1810;
const IMG_RATE = IMG_HEIGHT / CAR_HEIGHT;
const IMG_WIDTH = 813 * IMG_RATE;
const TIRES_TOP = 245 * IMG_RATE;
const TIRES_BOTTOM = 367 * IMG_RATE;
const TIRES_HEIGHT = 250 * IMG_RATE;
const TIRES_WIDTH = 96 * IMG_RATE;
const TIRES_RIGHT = 76 * IMG_RATE;
const TIRES_LEFT = 90 * IMG_RATE;

// 数据初始化
const domainControlStore = useDomainControlStore();
const forwardTurningFailure = ref("前转正常");
const reverseTurningFailure = ref("后转开启");
const forwardTurningIssue = ref(false);
// 轮胎数据
const tires = ref([
  {
    name: "左前",
    value: 0,
    status: "制动正常",
    disable: false,
    src: 轮胎左,
    position: { left: TIRES_LEFT, top: TIRES_TOP },
    gaugePosition: { left: -50, top: -35 },
    radioPosition: { left: -180, top: 25 },
    topValues: 0,
    bottomValues: 0,
  },
  {
    name: "右前",
    value: 0,
    status: "制动正常",
    disable: false,
    src: 轮胎左,
    position: { right: TIRES_RIGHT, top: TIRES_TOP },
    gaugePosition: { right: -50, top: -35 },
    radioPosition: { right: -180, top: 25 },
    topValues: 0,
    bottomValues: 0,
  },
  {
    name: "右后",
    value: 0,
    status: "制动正常",
    disable: false,
    src: 轮胎左,
    position: { right: TIRES_LEFT, bottom: TIRES_BOTTOM },
    gaugePosition: { right: -50, bottom: -35 },
    radioPosition: { right: -180, bottom: 25 },
    topValues: 0,
    bottomValues: 0,
  },
  {
    name: "左后",
    value: 0,
    status: "制动正常",
    disable: false,
    src: 轮胎左,
    position: { left: TIRES_RIGHT, bottom: TIRES_BOTTOM },
    gaugePosition: { left: -50, bottom: -35 },
    radioPosition: { left: -180, bottom: 25 },
    topValues: 0,
    bottomValues: 0,
  },
]);

// 处理通知数据
const handleNotify = async (data: DomianControl.IFTFNotifyData) => {
  tires.value.forEach((tire) => {
    switch (tire.name) {
      case "左前":
        tire.topValues = data.UIRx_WhlBrkTqAct_FL_BCh1 || 1;
        tire.bottomValues = data.UIRx_MotTq_FA || 1;
        break;
      case "右前":
        tire.topValues = data.UIRx_WhlBrkTqAct_FR_BCh1 || 1;
        tire.bottomValues = data.UIRx_MotTq_FA || 1;
        break;
      case "左后":
        tire.topValues = data.UIRx_WhlBrkTqAct_RL_BCh1 || 1;
        tire.bottomValues = data.UIRx_MotTq_RA || 1;
        break;
      case "右后":
        tire.topValues = data.UIRx_WhlBrkTqAct_RR_BCh1 || 1;
        tire.bottomValues = data.UIRx_MotTq_RA || 1;
        break;
    }
  });
};

// 解析输出值
const parseOutputValue = (value: DomianControl.OutputValue) => {
  const {
    UITx_DisableBrk_FL,
    UITx_DisableBrk_FR,
    UITx_DisableBrk_RL,
    UITx_DisableBrk_RR,
  } = value;
  handleSliderChange("UITx_SbTvRwsEna", 1);
  tires.value.forEach((tire) => {
    switch (tire.name) {
      case "左前":
        tire.status = parseStatus(UITx_DisableBrk_FL);
        break;
      case "右前":
        tire.status = parseStatus(UITx_DisableBrk_FR);
        break;
      case "左后":
        tire.status = parseStatus(UITx_DisableBrk_RL);
        break;
      case "右后":
        tire.status = parseStatus(UITx_DisableBrk_RR);
        break;
    }
  });
};

// 处理轮胎状态变化
const handleTireStatusChange = (index: number, value: FunctionStatus) => {
  const tire = tires.value[index];
  // 如果前转失效已经开启，则不允许将轮胎状态设置为“失效”
  if (forwardTurningFailure.value === "前转失效") {
    return;
  }

  tire.status = value;
  const data = {} as any;
  const signalValue = buildStatus(value);
  switch (tire.name) {
    case "左前":
      data.UITx_DisableBrk_FL = signalValue;
      break;
    case "右前":
      data.UITx_DisableBrk_FR = signalValue;
      break;
    case "左后":
      data.UITx_DisableBrk_RL = signalValue;
      break;
    case "右后":
      data.UITx_DisableBrk_RR = signalValue;
      break;
  }
  domainControlStore.writeOutputValue(data);
  updateTiresStatus();
};

// 更新轮胎状态
const updateTiresStatus = () => {
  const disableCount = tires.value.filter(
    (tire) => tire.status === "制动失效"
  ).length;
  if (disableCount > 0) {
    forwardTurningIssue.value = true;
  } else {
    forwardTurningIssue.value = false;
  }
  if (disableCount === 2 || forwardTurningFailure.value === "前转失效") {
    tires.value.forEach((tire) => {
      tire.disable = tire.status !== "制动失效";
    });
  } else {
    tires.value.forEach((tire) => {
      tire.disable = false;
    });
  }
};
const handleSliderChange = (type: string, value: number) => {
  domainControlStore.writeOutputValue({
    [type]: value,
  });
};

watch(
  () => forwardTurningFailure.value,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      const value = newValue === "前转失效" ? 3 : 0;
      handleSliderChange("UITx_SbTv_Ena", value);
      // 如果前转失效开启，则禁用所有轮胎的状态切换
      if (newValue === "前转失效") {
        tires.value.forEach((tire) => {
          tire.disable = true;
        });
      } else {
        updateTiresStatus();
      }
    }
  }
);
watch(
  () => reverseTurningFailure.value,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      const value = newValue === "后转开启" ? 1 : 0;
      handleSliderChange("UITx_SbTvRwsEna", value);
    }
  }
);

// 初始化
useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});
// 路由离开前的检查
onBeforeRouteLeave((to, from) => {
  console.log("离开");

  domainControlStore.writeOutputValue({
    UITx_SbTv_Ena: 0,
    UITx_SbTvRwsEna: 0,
    UITx_DisableBrk_FL: 0,
    UITx_DisableBrk_FR: 0,
    UITx_DisableBrk_RL: 0,
    UITx_DisableBrk_RR: 0,
  });
});
// onMounted(() => {
//   handleSliderChange("UITx_SbTvRwsEna", 1);
// });
// // 模拟数据更新
// onMounted(() => {
//   setInterval(() => {
//     handleNotify(generateMockIFTFNofifyData() as any);
//   }, 50);
// });
</script>

<style scoped lang="scss">
.car-img {
  :deep(.q-img__content) > div {
    background-color: transparent;
    padding: 0;
  }
}

.q-img {
  overflow: unset;
}

:deep(.q-toggle__inner--falsy) {
  .q-toggle__track {
    background: #4caf50;
  }
}

:deep(.q-radio__label) {
  font-size: 18px;
}

:deep(.q-radio.disabled) {
  opacity: 0.3 !important;
}

.arrow-group {
  &.top {
    top: 10px;
  }
  &.left {
    left: -40px;
  }
  &.right {
    right: -40px;
  }
  &.bottom {
    bottom: 10px;
  }
}

.arrow-bottom {
  margin-top: 10px;
  transform: rotate(180deg);
}

:deep(.q-linear-progress__stripe) {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.5) 25%,
    rgba(255, 255, 255, 0) 25%,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0.5) 75%,
    rgba(255, 255, 255, 0) 75%,
    rgba(255, 255, 255, 0)
  ) !important;
}
.hide-label .q-toggle__label {
  display: none !important;
}
.glowing-effect {
  position: relative;
  top: -15px;
  width: 70%;
  height: 10px; /* 根据需求调整高度 */
  margin: 0 auto;
}

.glowing-effect::before {
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    ellipse at center,
    rgb(255, 255, 255) 0%,
    rgba(255, 255, 255, 0) 70%
  ); /* 中间亮，边缘透明 */
  // box-shadow: 0 0 10px white, 0 0 20px white, 0 0 40px white;
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
</style>
